import type { ValidationResponseMessage } from '../../@types/common';

export abstract class BackgroundJobHandler<T> {
  apiProps: T;
  details: Record<string, unknown> | undefined;

  constructor(apiProps: T, details?: Record<string, unknown>) {
    this.apiProps = apiProps;
    this.details = details;
  }

  abstract createBackgroundJob(apiProps: T): Promise<{ backgroundJobId: number }>;
  abstract getJobDetails(backgroundJobId: number): Promise<{ status: string }>;
  abstract successCallback(response: Record<string, unknown>): Promise<void>;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  errorCallback(responseErrors?: ValidationResponseMessage[]): void {
    // each handler should override this method if needed
  }
}
